export default "https://cdn-static.gokick.com/assets/faf4ec4796b5499b7477edf17656e3681d9dd642/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";